import React from "react";
import { Route, Switch, Link } from "react-router-dom";
import SiteNav from "./SiteNav";

import Home from "../pages/Home";

import WebRoutes from "../routes/WebRoutes";

const MasterLayout = () => {
    return (
        <>
        <SiteNav />
        <main>
            <Switch>
                {
                    WebRoutes.map((route, idx)=> {
                        return (

                            route.component &&(
                                <Route 
                                key={idx}
                                path={route.path}
                                exact ={route.exact} 
                                //component ={route.component }
                                name={route.name}
                                render={(props)=>(<route.component {...props} />)}
                                //Not use component and render in a same Route....
                                />
                            )
                        )
                    })
                }
            </Switch>
        </main>
        </>
    );
}
export default MasterLayout;